import { render, staticRenderFns } from "./AfterFuteiki.vue?vue&type=template&id=d195094e&"
import script from "./AfterFuteiki.vue?vue&type=script&lang=js&"
export * from "./AfterFuteiki.vue?vue&type=script&lang=js&"
import style0 from "./AfterFuteiki.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports